/* eslint-disable react/no-array-index-key */
/**
 *
 * DataTable
 *
 */

import { PureComponent } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import DataTableRow from "./DataTableRow";

class DataTable extends PureComponent {
  state = {};

  render() {
    return (
      <Wrapper noScroll={this.props.noScroll}>
        {this.props.items.map((value, index) => (
          <Column
            key={index}
            multiColumnPracticeInfo={this.props.multiColumnPracticeInfo}
          >
            {value.map((value2, index2) => (
              <DataTableRow
                key={index2}
                item={value2}
                searchText={this.props.searchText}
                enableSearch={this.props.enableSearch}
                onSearchChange={this.props.onSearchChange}
                smallFirstColumn={this.props.smallFirstColumn}
                handleConfirm={this.props.handleConfirm}
                disabled={this.props.disabled}
                dropDown={this.props.dropDown}
                dropDownValue={this.props.dropDownValue}
                dropDownItems={this.props.dropDownItems}
                onPatientDelete={this.props.onPatientDelete}
              />
            ))}
          </Column>
        ))}
      </Wrapper>
    );
  }
}

DataTable.propTypes = {
  disabled: PropTypes.bool,
  items: PropTypes.array,
  handleConfirm: PropTypes.func,
  multiColumnPracticeInfo: PropTypes.bool,
  dropDown: PropTypes.bool,
  dropDownValue: PropTypes.any,
  dropDownItems: PropTypes.array,
  noScroll: PropTypes.bool,
  smallFirstColumn: PropTypes.bool,
  enableSearch: PropTypes.bool,
  searchText: PropTypes.string,
  onSearchChange: PropTypes.func,
  onPatientDelete: PropTypes.func,
};

DataTable.defaultProps = {};

const Column = styled.div`
  width: 100%;

  ${({ multiColumnPracticeInfo }) =>
    multiColumnPracticeInfo &&
    `
    @media (min-width: 600px) {
      &:first-child {
        width: 65%;
      }
  
      &:nth-child(2) {
        width: 50%;
      }
  
      &:last-child {
        width: 35%;
      }
    }
    
    @media (min-width: 700px) {
      &:first-child {
        width: 65%;
      }
  
      &:nth-child(2) {
        width: 50%;
      }
  
      &:last-child {
        width: 35%;
      }
    }
    
    @media (min-width: 975px) {
      &:first-child {
        width: 65%;
      }
  
      &:nth-child(2) {
        width: 50%;
      }
  
      &:last-child {
        width: 35%;
      }
    }
    
    @media (min-width: 1200px) {
      &:first-child {
        width: 60%;
      }
  
      &:nth-child(2) {
        width: 50%;
      }
  
      &:last-child {
        width: 35%;
      }
    }

  
  `};
`;

const Wrapper = styled.div`
  display: flex;
  border-radius: 10px;
  padding: 10px;

  ${({ noScroll }) => !noScroll && "overflow: auto"};

  ${({ theme }) => theme.phone`
    flex-direction: column;
  `};
`;

export default DataTable;
